import { render, staticRenderFns } from "./CustomDefinedField.vue?vue&type=template&id=2a5fee1b&scoped=true"
import script from "./CustomDefinedField.vue?vue&type=script&lang=ts"
export * from "./CustomDefinedField.vue?vue&type=script&lang=ts"
import style0 from "./CustomDefinedField.vue?vue&type=style&index=0&id=2a5fee1b&prod&scoped=true&lang=css"
import style1 from "./CustomDefinedField.vue?vue&type=style&index=1&id=2a5fee1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5fee1b",
  null
  
)

export default component.exports